@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-stackedbar-horizontal {
    padding: 0;

    // ==== Chart Background

    &.has-background {
      background-color: var(--background-color);
      box-shadow: var(--drop-shadow);
      border-radius: var(--G-border-radius);
    }

    // ==== Title

    .title-container {
      text-align: center;
      margin-block-start: 1em;
      margin-block-end: 1em;

      &:has(~ .subtitle-container) {
        margin-block-end: 0;
      }
    }

    // ==== Subtitle

    .subtitle-container {
      text-align: center;
      margin-block-end: 1em;
    }

    // ==== Legend

    .legend {
      text-align: center;
      margin-top: 1em;

      &:has(~ canvas) {
        margin-top: 0;
        margin-bottom: 1em;
      }
    }

    // ==== Legend Container

    .legend-container-horizontal,
    .legend-container-vertical {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      gap: 0.5em;
    }

    .legend-container-horizontal {
      flex-direction: row;

      @include screen-md {
        gap: 1em;
      }
    }

    .legend-container-vertical {
      flex-direction: column;
    }

    // ==== Legend Title

    .legend-title {
      flex: 1 0 100%;
    }

    // ==== Legend Label

    .legend-label-horizontal,
    .legend-label-vertical {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 0.5em;
      text-align: left;
      overflow: hidden;

      span {
        line-height: 1.25;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      svg {
        flex: 0 0 auto;
      }
    }

    .legend-label-horizontal {
      flex: 0 1 8em;

      @include screen-md {
        flex: 0 1 10em;
      }
      @include screen-lg {
        flex: 0 1 12em;
      }
    }

    // ==== Canvas

    canvas {
      display: block;
    }
  }
}
